import Vue from 'vue'

import ApiService from './api.service'
import { parseToken } from '@/utils/helper'

const TOKEN_KEY = 'access_token'
const REFRESH_TOKEN_KEY = 'refresh_token'
const ID_TOKEN_KEY = 'id_token'
const CURRENT_USER = 'currentUser'

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
**/

const TokenService = {
  getToken () {
    return Vue.cookie.get(TOKEN_KEY)
  },

  saveToken (accessToken) {
    Vue.cookie.set(TOKEN_KEY, accessToken)
  },

  removeToken () {
    Vue.cookie.delete(TOKEN_KEY)
  },

  getRefreshToken () {
    return Vue.cookie.get(REFRESH_TOKEN_KEY)
  },

  saveRefreshToken (refreshToken) {
    Vue.cookie.set(REFRESH_TOKEN_KEY, refreshToken)
  },

  removeRefreshToken () {
    Vue.cookie.delete(REFRESH_TOKEN_KEY)
  },

  getIdToken () {
    let token = Vue.cookie.get(TOKEN_KEY)
    return token !== undefined ? Vue.cookie.get(TOKEN_KEY) : false
  },

  saveIdToken (idToken) {
    Vue.cookie.set(ID_TOKEN_KEY, idToken)
  },

  removeIdToken () {
    Vue.cookie.delete(ID_TOKEN_KEY)
  },

  saveCurrentUser (currentUser) {
    localStorage.setItem(CURRENT_USER, JSON.stringify(currentUser))
  },

  getCurrentUser () {
    return JSON.parse(localStorage.getItem(CURRENT_USER))
  },

  purge () {
    localStorage.clear()
    this.removeIdToken()
    this.removeRefreshToken()
    this.removeToken()
  },

  isTokenExpired () {
    let token = Vue.cookie.get(TOKEN_KEY)
    if (token) {
      let accessToken = parseToken(token)
      if (accessToken.exp) {
          let current_time
          current_time = Math.floor(new Date().getTime() / 1000.0)
          return accessToken.exp < current_time
      }
    }
    return false
  }
}

export { TokenService }
